
















































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'product-sectors-modal',
    components: {
        Spinner,
    },
    computed: {
        ...mapState('productSectors', ['activeProductSectorLoading', 'activeProductSector']),
    },
})
export default class ProductSectorsModal extends Vue {
    //
    private activeProductSector!: any;
    private activeProductSectorLoading!: any;

    private searchQuery: string = '';

    onSaveProductSector() {
        this.activeProductSector.slug = this.string_to_slug(this.activeProductSector.name);
        if (this.activeProductSector.id == 0) {
            this.$store.dispatch('productSectors/postOne', {
                vm: this,
                data: this.activeProductSector,
            });
        } else {
            this.$store.dispatch('productSectors/putOne', {
                vm: this,
                data: this.activeProductSector,
            });
        }
    }

    string_to_slug(str: string) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        var from = 'àáãäâèéëêìíïîòóöôùúüûñç·/_,:;';
        var to = 'aaaaaeeeeiiiioooouuuunc------';

        for (var i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str
            .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes

        return str;
    }
}
